import OptionAwardsApproval from '../pages/option-awards/optionsAwardsApproval';
import ParticipantsApproval from '../pages/participants/participantApproval';
import PsuAwardsApproval from '../pages/psu-awards/psuAwardsApproval';
import RsuAwardsApproval from '../pages/rsu-awards/rsuAwardsApproval';
import ApprovalConfig from '../pages/settings/approval-config';
import BankAccount from '../pages/settings/bank-account';
import CompanyProfile from '../pages/settings/company-profile';
import CustomerSwitch from '../pages/settings/customer-switch';
import CompanyMapping from '../pages/settings/customer_success';
import DepartmentComponent from '../pages/settings/department';
import EmailLogs from '../pages/settings/email-service';
import EmployeeTypesComponent from '../pages/settings/employee-types';
import FeatureSet from '../pages/settings/feature-set';
import FinchComponent from '../pages/settings/finch';
import GrantManagement from '../pages/settings/grant-management';
import GrantManagementList from '../pages/settings/grant-management/grantList';
import JobTitleComponent from '../pages/settings/job-title';
import ParticipantBroadcast from '../pages/settings/participant-boadcast';
import PerformanceRules from '../pages/settings/performance-rule';
import PerformanceRuleApproval from '../pages/settings/performance-rule/performanceRuleApproval';
import PlanManagement from '../pages/settings/plan-management';
import PlanManagementApproval from '../pages/settings/plan-management/planManagementApproval';
import PushToProduction from '../pages/settings/push-to-production';
import RetirementEligibility from '../pages/settings/retirement-eligibility';
import RoleMapping from '../pages/settings/role-mapping';
import RolePublish from '../pages/settings/role-publish';
import SandboxSwitch from '../pages/settings/sandbox';
import SettlementConfig from '../pages/settings/settlement-config';
import SharePoolManagement from '../pages/settings/sharepool-management';
import SystemRoles from '../pages/settings/system-roles';
import SystemUsers from '../pages/settings/system-users';
import SystemUserApproval from '../pages/settings/system-users/systemUserApproval';
import TaxLibrary from '../pages/settings/tax/tax-library';
import TaxYear from '../pages/settings/tax/tax-period';
import TaxSetup from '../pages/settings/tax/tax-setup';
import TaxSetupApprover from '../pages/settings/tax/tax-setup/taxSetupApprover';
import TermAndCondition from '../pages/settings/term-and-condition';
import TradePreClearanceList from '../pages/settings/trade-pre-clearance';
import TradingBlackoutConfiguration from '../pages/settings/trading-black-out-configuration';
import UserDefineFields from '../pages/settings/udf';
import VestingTemplates from '../pages/settings/vesting-templates';
import EmailTemplate from '../pages/email-template';
import Fee from '../pages/settings/fee';
import FmvConfiguration from '../pages/settings/fmv-configuration';
import Commission from '../pages/settings/commission';
import SsoConfiguration from '../pages/sso-configuration';
import GrantAcceptanceTemplate from '../pages/settings/grant-acceptance-template';
import TransactionConfig from '../pages/settings/transaction-config';
import CompanyTnC from '../pages/settings/term-and-condition/companyTnC';
import VendorBrokerTnC from '../pages/settings/term-and-condition/vendorBrokerTnC';
import TransferAgentSetting from '../pages/settings/transfer-agent-setting';
import AllInOneImport from '../pages/all-in-one-import';
import WhiteLabelConfiguration from '../pages/settings/white-label-configuration';
import { Ingest } from '../components/ingest';
import { PlatformKB } from '../components/platform-kb';
import PermissionManagement from '../pages/settings/permission-management';
import SearchPermissionOnUse from '../pages/settings/permission-management/searchPermissionOnUse';
import DisbursementConfig from '../pages/settings/disbursement-config';
import IsoConfiguration from '../pages/settings/iso-configuration';
import CompanyAccountingPolicy from '../pages/settings/company-accounting-policy';
import BrokerageSSOConfiguration from '../pages/settings/brokerage-sso-configuration';
import AlertSubscription from '../pages/settings/alert-subscription';
import SystemAlertConfiguration from '../pages/settings/system-alert-configuration';

export enum Level {
  Company = 'company',
  Instance = 'instance',
}

export const OrganizationSettingsList = [
  {
    showOnList: true,
    url: 'company-profile',
    slug: 'company-profile',
    title: 'Company Profile',
    name: 'Companies',
    category: 'My Account',
    level: Level.Company,
    component: <CompanyProfile />,
  },
  {
    showOnList: true,
    url: 'users',
    slug: 'users',
    title: 'System Users',
    name: 'CustomerUsers',
    category: 'System Users & Roles',
    level: Level.Company,
    component: <SystemUsers />,
  },
  {
    showOnList: true,
    url: 'roles',
    slug: 'roles',
    title: 'System Roles',
    name: 'CustomerRoles',
    category: 'System Users & Roles',
    level: Level.Company,
    component: <SystemRoles />,
  },
  {
    showOnList: true,
    url: 'system-approvers',
    slug: 'system-approvers',
    title: 'System Approvers',
    name: 'SystemApprovers',
    category: 'System Users & Roles',
    level: Level.Company,
    component: <ApprovalConfig />,
  },
  // {
  //   showOnList: true,
  //   url: 'users',
  //   slug: 'users',
  //   title: 'System Users',
  //   name: 'VendorUsers',
  //   category: 'System Users & Roles',
  //   component: <SystemUsers />,
  // },
  // {
  //   showOnList: true,
  //   url: 'roles',
  //   slug: 'roles',
  //   title: 'System Roles',
  //   name: 'VendorRoles',
  //   category: 'System Users & Roles',
  //   component: <SystemRoles />,
  // },
  // {
  //   showOnList: true,
  //   url: 'customer-success',
  //   slug: 'customer-success',
  //   title: 'Switch Company',
  //   name: 'SwitchCompany',
  //   category: 'Customer Success',
  //   component: <CustomerSwitch />,
  // },
  {
    showOnList: true,
    url: 'role-publish',
    slug: 'role-publish',
    title: 'Role Publish',
    name: 'RolePublishedToCompany',
    category: 'Customer Success',
    level: Level.Company,
    component: <RolePublish />,
  },
  {
    showOnList: true,
    url: 'role-mapping',
    slug: 'role-mapping',
    title: 'Role Mapping',
    name: 'AllowedRoleMapping',
    category: 'Customer Success',
    level: Level.Company,
    component: <RoleMapping />,
  },
  {
    showOnList: true,
    url: 'company-mapping',
    slug: 'company-mapping',
    title: 'Company Mapping',
    name: 'AllowedCompanyMapping',
    category: 'Customer Success',
    level: Level.Company,
    component: <CompanyMapping />,
  },
  {
    showOnList: true,
    url: 'sandbox',
    slug: 'sandbox',
    title: 'Sandbox',
    name: 'Sandbox',
    category: 'Sandbox',
    level: Level.Company,
    component: <SandboxSwitch />,
  },
  {
    showOnList: true,
    url: 'push-to-production',
    slug: 'push-to-production',
    title: 'Load To Main Logs',
    name: 'Production',
    category: 'Sandbox',
    level: Level.Company,
    component: <PushToProduction />,
  },
  {
    showOnList: true,
    url: 'feature-set',
    slug: 'feature-set',
    title: 'Feature Set',
    name: 'FeatureSet',
    category: 'Feature Set',
    level: Level.Company,
    component: <FeatureSet />,
  },
  {
    showOnList: false,
    url: 'permission-manager',
    slug: 'permission-manager',
    title: 'Permission Manager',
    name: 'FeatureSet',
    category: 'Permission Manager',
    level: Level.Company,
    component: <PermissionManagement />,
  },
  {
    showOnList: false,
    url: 'search-permission-on-use',
    slug: 'search-permission-on-use',
    title: 'Permission On Use',
    name: 'FeatureSet',
    category: 'Permission Manager',
    level: Level.Company,
    component: <SearchPermissionOnUse />,
  },
  {
    showOnList: true,
    url: 'department',
    slug: 'department',
    title: 'Departments',
    name: 'CustomerDepartments',
    category: 'Participant Settings',
    level: Level.Instance,
    component: <DepartmentComponent />,
  },
  {
    showOnList: true,
    url: 'job-title',
    slug: 'job-title',
    title: 'Job Titles',
    name: 'CustomerTitles',
    category: 'Participant Settings',
    level: Level.Instance,
    component: <JobTitleComponent />,
  },
  {
    showOnList: true,
    url: 'employee-types',
    slug: 'employee-types',
    title: 'Employee Types',
    name: 'CustomerEmployeeTypes',
    category: 'Participant Settings',
    level: Level.Instance,
    component: <EmployeeTypesComponent />,
  },
  {
    showOnList: true,
    url: 'plan-management',
    slug: 'plan-management',
    title: 'Plan Management',
    name: 'Plans',
    category: 'Award Management',
    level: Level.Instance,
    component: <PlanManagement />,
  },
  {
    showOnList: true,
    url: 'grant-management',
    slug: 'grant-management',
    title: 'Grant Management',
    name: 'Plans',
    category: 'Award Management',
    level: Level.Instance,
    component: <GrantManagement />,
  },
  {
    showOnList: true,
    url: 'sharepool-management',
    slug: 'sharepool-management',
    title: 'Share Pool Management',
    name: 'Plans',
    category: 'Award Management',
    level: Level.Instance,
    component: <SharePoolManagement />,
  },
  {
    showOnList: true,
    url: 'vesting-templates',
    slug: 'vesting-templates',
    title: 'Vesting Templates',
    name: 'VestingTemplates',
    category: 'Award Management',
    level: Level.Instance,
    component: <VestingTemplates />,
  },
  {
    showOnList: true,
    url: 'performance-rule',
    slug: 'performance-rule',
    title: 'Performance Rules',
    name: 'PerformanceRule',
    category: 'Award Management',
    level: Level.Instance,
    component: <PerformanceRules />,
  },

  {
    showOnList: true,
    url: 'tax-period',
    slug: 'tax-period',
    title: 'Tax Period',
    name: 'CompanyTax',
    category: 'Tax',
    level: Level.Instance,
    component: <TaxYear />,
  },
  {
    showOnList: true,
    url: 'tax-setup',
    slug: 'tax-setup',
    title: 'Tax Setup',
    name: 'CompanyTax',
    category: 'Tax',
    level: Level.Instance,
    component: <TaxSetup />,
  },
  {
    showOnList: true,
    url: 'tax-library',
    slug: 'tax-library',
    title: 'Tax Library',
    name: 'CompanyTax',
    category: 'Tax',
    level: Level.Instance,
    component: <TaxLibrary />,
  },
  {
    showOnList: true,
    url: 'finch',
    slug: 'finch',
    title: 'HR Payroll Integration',
    name: 'HRIntergration',
    category: 'Configuration',
    level: Level.Instance,
    component: <FinchComponent />,
  },
  {
    showOnList: true,
    url: 'sso-configuration',
    slug: 'sso-configuration',
    title: 'SSO Configuration',
    name: 'SsoConfiguration',
    category: 'Configuration',
    level: Level.Instance,
    component: <SsoConfiguration />,
  },
  {
    showOnList: true,
    url: 'vendor-broker-terms-and-conditions',
    slug: 'vendor-broker-terms-and-conditions',
    title: 'Vendor & Broker T&C',
    name: 'VendorTermsAndConditions',
    category: 'T&Cs, Regulatory & Other Legal Documents',
    level: Level.Instance,
    component: <VendorBrokerTnC />,
  },
  {
    showOnList: true,
    url: 'company-terms-and-conditions',
    slug: 'company-terms-and-conditions',
    title: 'Company T&C',
    name: 'TermsAndConditions',
    category: 'T&Cs, Regulatory & Other Legal Documents',
    level: Level.Instance,
    component: <CompanyTnC />,
  },
  // {
  //   showOnList: true,
  //   url: 'terms-and-conditions',
  //   slug: 'terms-and-conditions',
  //   title: 'T&Cs, Regulatory & Other Legal Documents',
  //   name: 'TermsAndConditions',
  //   category: 'Others',
  //   level: Level.Instance,
  //   component: <TermAndCondition />,
  // },
  {
    showOnList: true,
    url: 'trade-pre-clearance',
    slug: 'trade-pre-clearance',
    title: 'Trade Pre-Clearance',
    name: 'TradePreClearance',
    category: 'Others',
    level: Level.Instance,
    component: <TradePreClearanceList />,
  },
  {
    showOnList: true,
    url: 'trading-black-out-configuration',
    slug: 'trading-black-out-configuration',
    title: 'Trading Black-out Configuration',
    name: 'TradingBlackOut',
    category: 'Others',
    level: Level.Instance,
    component: <TradingBlackoutConfiguration />,
  },
  {
    showOnList: true,
    url: 'bank-account',
    slug: 'bank-account',
    title: 'Bank Account',
    name: 'Banks',
    category: 'Others',
    level: Level.Instance,
    component: <BankAccount />,
  },
  {
    showOnList: true,
    url: 'udf',
    slug: 'udf',
    title: 'UDF',
    name: 'UDF',
    category: 'Others',
    level: Level.Instance,
    component: <UserDefineFields />,
  },
  {
    showOnList: false,
    url: 'tax-management',
    slug: 'tax-management',
    title: 'Tax Management',
    name: 'CustomerTax',
    category: 'Others',
    level: Level.Instance,
    component: <h1>Bank Account</h1>,
  },
  {
    showOnList: true,
    url: 'all-in-one-import',
    slug: 'all-in-one-import',
    title: 'All In One Import',
    name: 'Companies',
    category: 'Others',
    level: Level.Instance,
    component: <AllInOneImport />,
    exact: true,
  },
  {
    showOnList: true,
    url: 'blackout-config',
    slug: 'blackout-config',
    title: 'Blackout Config',
    name: 'BlackoutConfigs',
    category: 'Award Management',
    level: Level.Instance,
    component: <h1>Bank Account</h1>,
  },
  {
    showOnList: true,
    url: 'settlement-config',
    slug: 'settlement-config',
    title: 'Settlement Configuration',
    name: [
      'SettlementConfigs',
      'ElectionWindowConfigurations',
      'TradePreClearanceTransactionPeriodConfigs',
    ],
    category: 'Others',
    level: Level.Instance,
    component: <SettlementConfig />,
  },
  {
    showOnList: true,
    url: 'retirement-config',
    slug: 'retirement-config',
    title: 'Retirement Configuration',
    name: 'RetirementEligibilityConfigs',
    category: 'Others',
    level: Level.Instance,
    component: <RetirementEligibility />,
  },
  // {
  //   showOnList: true,
  //   url: 'system-approvers',
  //   slug: 'system-approvers',
  //   title: 'System Approvers',
  //   name: 'VendorApprovers',
  //   category: 'System Users & Roles',
  //   component: <ApprovalConfig />,
  // },
  {
    showOnList: false,
    url: 'grant-management/:id',
    slug: 'grant-management',
    title: 'Grant Management',
    name: 'Plans',
    category: 'Others',
    level: Level.Instance,
    component: <GrantManagement />,
  },
  {
    showOnList: false,
    url: 'grant-list',
    slug: 'grant-list',
    title: 'Grant list',
    name: 'Plans',
    category: 'Others',
    level: Level.Instance,
    component: <GrantManagementList />,
  },
  {
    showOnList: true,
    url: 'user-defined-field',
    slug: 'user-defined-field',
    title: 'User Defined Fields',
    name: 'UserDefinedFields',
    category: 'Others',
    level: Level.Instance,
    component: <UserDefineFields />,
  },
  {
    showOnList: true,
    url: 'participant-broadcast',
    slug: 'participant-broadcast',
    title: 'Participant Broadcast',
    name: 'ParticipantBroadcastMessages',
    category: 'Participant Settings',
    level: Level.Instance,
    component: <ParticipantBroadcast />,
  },

  {
    showOnList: true,
    url: 'email-logs',
    slug: 'email-logs',
    title: 'Email Logs',
    name: 'Notification',
    category: 'Others',
    level: Level.Instance,
    component: <EmailLogs />,
  },
  {
    showOnList: true,
    url: 'email-template',
    slug: 'email-template',
    title: 'Email Template',
    name: 'NotificationTemplate',
    category: 'Others',
    component: <EmailTemplate />,
  },
  {
    showOnList: true,
    url: 'broker-sso-configuration',
    slug: 'broker-sso-configuration',
    title: 'Broker SSO Configuration',
    name: 'BrokerSsoConfiguration',
    category: 'Others',
    component: <BrokerageSSOConfiguration />,
  },
  {
    showOnList: true,
    url: 'alert-subscription',
    slug: 'alert-subscription',
    title: 'Alert Subscription',
    name: 'ManageAlertSubscription',
    category: 'Others',
    level: Level.Instance,
    component: <AlertSubscription />,
  },
  {
    showOnList: true,
    url: 'grant-acceptance-template',
    slug: 'grant-acceptance-template',
    title: 'Grant Acceptance Template',
    name: 'Notice',
    category: 'Award Management',
    component: <GrantAcceptanceTemplate />,
  },
  {
    showOnList: true,
    url: 'task/user-approval',
    slug: 'task/user-approval',
    permissionName: 'CustomerUserApproval',
    title: 'System User Approval',
    name: 'CustomerUserApproval',
    category: 'Approval Console',
    level: Level.Instance,
    // component: <SystemUserApproval />,
  },
  {
    showOnList: true,
    url: 'task/plan-approval',
    slug: 'task/plan-approval',
    permissionName: 'PlanApproval',
    title: 'Plan Approval',
    name: 'PlanApproval',
    category: 'Approval Console',
    level: Level.Instance,
    // component: <PlanManagementApproval />,
  },
  {
    showOnList: true,
    url: 'task/participants-approval',
    slug: 'task/participants-approval',
    permissionName: 'ParticipantApproval',
    title: 'Participant Approval',
    name: 'ParticipantApproval',
    category: 'Approval Console',
    level: Level.Instance,
    // component: <ParticipantsApproval />,
  },
  {
    showOnList: true,
    url: 'task/rsu-awards-approval',
    slug: 'task/rsu-awards-approval',
    permissionName: 'RSUAwardApproval',
    title: 'RSU Awards Approval',
    name: 'RSUAwardApproval',
    category: 'Approval Console',
    level: Level.Instance,
    // component: <RsuAwardsApproval />,
  },
  {
    showOnList: true,
    url: 'task/psu-awards-approval',
    slug: 'task/psu-awards-approval',
    permissionName: 'PSUAwardApproval',
    title: 'PSU Awards Approval',
    name: 'PSUAwardApproval',
    category: 'Approval Console',
    level: Level.Instance,
    // component: <PsuAwardsApproval />,
  },
  {
    showOnList: true,
    url: 'task/option-awards-approval',
    slug: 'task/option-awards-approval',
    permissionName: 'OptionAwardApproval',
    title: 'Option Awards Approval',
    name: 'OptionAwardApproval',
    category: 'Approval Console',
    level: Level.Instance,
    // component: <OptionAwardsApproval />,
  },
  {
    showOnList: true,
    url: 'task/pre-clearance-requests',
    slug: 'task/pre-clearance-requests',
    permissionName: 'TradePreClearanceApproval',
    title: 'Trade Pre-Clearance Approval',
    name: 'TradePreClearanceApproval',
    category: 'Approval Console',
    level: Level.Instance,
    // component: <OptionAwardsApproval />,
  },
  {
    showOnList: true,
    url: 'task/tax-setup-approval',
    slug: 'task/tax-setup-approval',
    permissionName: 'TaxApproval',
    title: 'Tax Approval',
    name: 'TaxApproval',
    category: 'Approval Console',
    level: Level.Instance,
    // component: <TaxSetupApprover />,
  },
  {
    showOnList: true,
    url: 'task/performance-rule-approval',
    slug: 'task/performance-rule-approval',
    permissionName: 'PerformanceRuleApproval',
    title: 'Performance Rule Approval',
    name: 'PerformanceRuleApproval',
    category: 'Approval Console',
    level: Level.Instance,
    // component: <PerformanceRuleApproval />,
  },
  {
    showOnList: true,
    url: 'fee',
    slug: 'fee',
    title: 'Fee',
    name: 'Fee',
    category: 'Configuration',
    level: Level.Instance,
    component: <Fee />,
  },
  {
    showOnList: true,
    url: 'commission',
    slug: 'commission',
    title: 'Commission',
    name: 'Commission',
    category: 'Configuration',
    level: Level.Instance,
    component: <Commission />,
  },
  {
    showOnList: true,
    url: 'fmv-configuration',
    slug: 'fmv-configuration',
    title: 'FMV Configuration',
    name: 'FMVConfiguration',
    category: 'Configuration',
    level: Level.Instance,
    component: <FmvConfiguration />,
  },
  {
    showOnList: true,
    url: 'transaction-configuration',
    slug: 'transaction-configuration',
    title: 'Transaction Configuration',
    name: 'Plans',
    // name: 'TransactionConfiguration',
    category: 'Configuration',
    level: Level.Instance,
    component: <TransactionConfig />,
  },
  {
    showOnList: true,
    url: 'chatbot-ingest',
    slug: 'chatbot-ingest',
    title: 'AI Knowledge Base Management',
    name: 'ChatBotDocument',
    category: 'Configuration',
    level: Level.Instance,
    component: <Ingest />,
  },
  {
    showOnList: true,
    url: 'platform-kb',
    slug: 'platform-kb',
    title: 'Platform Knowledge Base',
    name: 'ChatBotDocument',
    category: 'Configuration',
    level: Level.Instance,
    component: <PlatformKB />,
  },
  {
    showOnList: true,
    url: 'system-alert-configuration',
    slug: 'system-alert-configuration',
    title: 'System Alert Configuration',
    name: 'SystemAlertConfiguration',
    category: 'Configuration',
    level: Level.Instance,
    component: <SystemAlertConfiguration />,
  },
  // {
  //   showOnList: true,
  //   url: 'iso-configuration',
  //   slug: 'iso-configuration',
  //   title: 'ISO Configuration',
  //   name: 'IsoConfiguration',
  //   category: 'Configuration',
  //   level: Level.Instance,
  //   component: <IsoConfiguration />,
  // },
  // {
  //   showOnList: true,
  //   url: 'document-detail',
  //   slug: 'document-detail',
  //   title: 'Document Detail',
  //   name: 'Companies',
  //   category: 'Configuration',
  //   level: Level.Instance,
  //   component: <DocumentDetail />,
  // },
  {
    url: 'disbursement-configuration',
    slug: 'disbursement-configuration',
    title: 'Disbursement Configuration',
    name: 'DisbursementValidation',
    category: 'Configuration',
    level: Level.Instance,
    component: <DisbursementConfig />,
  },
  {
    showOnList: true,
    url: 'transfer-agent-setting',
    slug: 'transfer-agent-setting',
    title: 'Transfer Agent Setting',
    name: 'TAIntegration',
    category: 'Configuration',
    level: Level.Instance,
    component: <TransferAgentSetting />,
  },
  {
    showOnList: true,
    url: 'branding-package-configuration',
    slug: 'branding-package-configuration',
    title: 'Branding Package',
    name: 'BrandingPackage',
    category: 'Configuration',
    level: Level.Company,
    component: <WhiteLabelConfiguration />,
  },
  {
    showOnList: true,
    url: 'company-accounting-policy',
    slug: 'company-accounting-policy',
    title: 'Company Accounting Policy',
    name: 'CompanyAccountingPolicy',
    category: 'Others',
    level: Level.Company,
    component: <CompanyAccountingPolicy />,
  },
];

export const ComponentsNames = [
  {
    url: 'company-profile',
    name: 'Companies',
  },
  {
    url: 'vesting-templates',
    name: 'VestingTemplates',
  },
  {
    url: 'performance-rule',
    name: 'PerformanceRule',
  },
  {
    url: 'trade-pre-clearance',
    name: 'TradePreClearance',
  },
  {
    url: 'trading-black-out-configuration',
    name: 'TradingBlackOut',
  },
  {
    url: 'notification',
    name: 'Notification',
  },
  {
    url: 'users',
    name: 'CustomerUsers',
  },
  {
    url: 'settlement-config',
    name: 'SettlementConfigs',
  },
  {
    url: 'retirement-config',
    name: 'RetirementConfigs',
  },
  {
    url: 'election-window-config',
    name: 'ElectionWindowConfigurations',
  },
  {
    url: 'plan-management',
    name: 'Plans',
  },
  {
    url: 'grant-management',
    name: 'Plans',
  },
  {
    url: 'sharepool-management',
    name: 'Plans',
  },
  {
    url: 'roles',
    name: 'CustomerRoles',
  },
  {
    url: 'department',
    name: 'CustomerDepartments',
  },
  {
    url: 'job-title',
    name: 'CustomerTitles',
  },
  {
    url: 'employee-types',
    name: 'CustomerEmployeeTypes',
  },
  {
    url: 'system-approvers',
    name: 'SystemApprovers',
  },
  {
    url: 'grant-management',
    name: 'Grants',
  },
  {
    url: 'grant-list',
    name: 'Grants',
  },
  {
    url: 'plan-approvals',
    name: 'PlanApproval',
  },
  {
    url: 'bank-account',
    name: 'Banks',
  },
  {
    url: 'rsu-awards',
    name: 'RSUAwards',
  },
  {
    url: 'psu-awards',
    name: 'PSUAwards',
  },
  {
    url: 'option-awards',
    name: 'OptionAwards',
  },
  {
    url: 'unified-awards',
    name: ['RSUAwards', 'PSUAwards', 'OptionAwards'],
  },
  {
    url: 'awards-agreement',
    name: 'AwardAgreement',
  },
  {
    url: 'participants',
    name: 'Participants',
  },
  {
    url: 'vendor-broker-terms-and-conditions',
    name: 'VendorTermsAndConditions',
  },
  {
    url: 'company-terms-and-conditions',
    name: 'TermsAndConditions',
  },
  //   {
  //   url: 'terms-and-conditions',
  //   name: 'TermsAndConditions',
  // },
  {
    url: 'user-defined-field',
    name: 'UserDefinedFields',
  },
  {
    url: 'participant-broadcast',
    name: 'ParticipantBroadcastMessages',
  },
  {
    url: 'tax-setup',
    name: 'CompanyTax',
  },
  {
    url: 'tax-period',
    name: 'CompanyTax',
  },
  {
    url: 'reports',
    name: 'DynamicReport',
  },
  {
    url: 'task-management-console',
    name: 'TaskManagerConsole',
  },
  {
    url: 'email-logs',
    name: 'Notification',
  },
  {
    url: 'grant-acceptance-template',
    name: 'Notice',
  },
  {
    url: 'espp',
    name: 'OfferingPeriod',
  },
  {
    url: '/transactions/exercise',
    name: 'OptionExercise',
  },
  {
    url: '/task/user-approval',
    permissionName: 'CustomerUserApproval',
    name: 'System User Approval',
  },
  {
    url: 'customer-success',
    name: 'Customer Success',
  },
  {
    url: 'role-publish',
    name: 'RolePublishedToCompany',
  },
  {
    url: 'role-mapping',
    name: 'AllowedRoleMapping',
  },
  {
    url: 'customer-list',
    name: 'Company',
  },
  {
    url: 'customer-list/create',
    name: 'Company',
  },
  {
    url: 'brokerage-import-export',
    name: 'BrokerageImportExport',
  },
  {
    url: 'dashboard/brokerage-account/list',
    name: 'BrokerageImportExport',
  },
  {
    url: 'dashboard/brokerage-account',
    name: 'BrokerageImportExport',
  },
  {
    url: 'dashboard/trade-order/list',
    name: 'BrokerageImportExport',
  },
  {
    url: 'dashboard/trade-order',
    name: 'BrokerageImportExport',
  },
  {
    url: 'dashboard/transfer-and-allocate',
    name: 'BrokerageImportExport',
  },
  {
    url: 'dashboard/transfer-and-allocate/pending-shares',
    name: 'BrokerageImportExport',
  },
  {
    url: 'dashboard/transfer-and-allocate/details',
    name: 'BrokerageImportExport',
  },
  // {
  //   url: 'transfer-agent/drs-registration',
  //   name: 'DrsInstruction',
  // },
  {
    url: 'transfer-agent/drs-registration/pending-shares',
    name: 'DrsInstruction',
  },
  // {
  //   url: 'transfer-agent/drs-registration/details',
  //   name: 'DrsInstruction',
  // },

  {
    url: 'dashboard/disbursement',
    name: 'BrokerageImportExport',
  },
  {
    url: 'dashboard/disbursement/details',
    name: 'BrokerageImportExport',
  },
  {
    url: 'sandbox',
    name: 'Sandbox',
  },
  {
    url: 'dashboard/brokerage-account',
    name: 'Companies',
  },
  {
    url: 'dashboard/trade-order',
    name: 'Companies',
  },
  {
    url: 'brokerage-account',
    name: 'Companies',
  },
  {
    url: 'trade-order',
    name: 'Companies',
  },
  {
    url: 'commission',
    name: 'Commission',
  },
  {
    url: 'fee',
    name: 'fee',
  },
  {
    url: 'feature-set',
    name: 'FeatureSet',
  },
  {
    url: 'permission-manager',
    name: 'PermissionManager',
  },
  {
    url: 'company-mapping',
    name: 'AllowedCompanyMapping',
  },
  {
    url: 'push-to-production',
    name: 'Production',
  },
  {
    url: 'fmv-configuration',
    name: 'FMVConfiguration',
  },
  {
    url: 'transaction-configuration',
    name: 'Plans',
    // name: 'TransactionConfiguration',
  },
  {
    url: 'transfer-agent-setting',
    name: 'TAIntegration',
  },
  {
    url: 'transfer-agent',
    name: 'DrsInstruction',
  },

  // {
  //   url: 'transactions/purchase',
  //   name: 'Companies',
  // },
  {
    url: 'job-scheduler',
    name: 'Scheduler',
  },
  {
    url: 'sandbox-configuration',
    name: 'SandboxConfiguration',
  },
  {
    url: 'sso-configuration',
    name: 'SsoConfiguration',
  },
  {
    url: 'export-pdf',
    name: 'HoldingExporter',
  },
  {
    url: 'iso-configuration',
    name: 'IsoConfiguration',
  },
  {
    url: 'branding-package-configuration',
    name: 'BrandingPackage',
  },
  {
    url: 'broker-sso-configuration',
    name: 'BrokerSsoConfiguration',
  },
  {
    url: 'platform-kb',
    name: 'ChatBotDocument',
  },
  {
    url: 'company-accounting-policy',
    name: 'CompanyAccountingPolicy',
  },
];

export const MyTaskRouteList = [
  {
    url: '/task/user-approval',
    permissionName: 'CustomerUserApproval',
    name: 'System User Approval',
  },
  {
    url: '/task/participants-approval',
    permissionName: 'ParticipantApproval',
    name: 'Participant Approval',
  },
  {
    url: '/task/rsu-awards-approval',
    permissionName: 'RSUAwardApproval',
    name: 'RSU Awards Approval',
  },
  {
    url: '/task/psu-awards-approval',
    permissionName: 'PSUAwardApproval',
    name: 'PSU Awards Approval',
  },
  {
    url: '/task/plan-approval',
    permissionName: 'PlanApproval',
    name: 'Plan Approval',
  },
  {
    url: '/task/settlement-config-approval',
    permissionName: 'SettlementConfigs',
    name: 'Settlement Config Approval',
  },
  {
    url: '/task/option-awards-approval',
    permissionName: 'OptionAwardApproval',
    name: 'Option Awards Approval',
  },
  {
    url: '/task/pre-clearance-requests',
    permissionName: 'TradePreClearanceApproval',
    name: 'Trade Pre-Clearance Approval',
  },
  {
    url: '/settings/organization-settings/plan-management',
    permissionName: 'Plans',
    name: 'Replenish Share Pool',
  },
  {
    url: '/settings/organization-settings/plan-management',
    permissionName: 'Plans',
    name: 'Plan Expiry',
  },
  {
    url: '/settings/organization-settings/sharepool-management',
    permissionName: 'Plans',
    name: 'Share Pool Management',
  },
  {
    url: '/task/tax-setup-approval',
    permissionName: 'TaxApproval',
    name: 'Tax Approval',
  },
  {
    url: '/task/performance-rule-approval',
    permissionName: 'PerformanceRuleApproval',
    name: 'Performance Rule Approval',
  },
  {
    url: '/settings/organization-settings/performance-rule',
    permissionName: 'PerformanceRule',
    name: 'Multiplier Entry',
  },
  {
    url: '/transactions/exercise',
    permissionName: 'OptionExercise',
    name: 'Exercise pending',
  },
];

export const EquityAwardsList = [
  {
    url: '/awards/rsu-awards',
    permissionName: 'RSUAwards',
    name: 'Restricted Stock',
  },
  {
    url: '/awards/option-awards',
    permissionName: 'OptionAwards',
    name: 'Option Awards',
  },
  {
    url: '/awards/psu-awards',
    permissionName: 'PSUAwards',
    name: 'PSU Awards',
  },
  {
    url: '/espp',
    permissionName: 'OfferingPeriod',
    name: 'ESPP',
  },
  {
    url: '/awards/fair-value',
    permissionName: ['RSUAwards', 'OptionAwards', 'PSUAwards'],
    name: 'Fair Value',
  },
  {
    url: '/awards/unified-award-import',
    permissionName: ['RSUAwards', 'OptionAwards', 'PSUAwards'],
    name: 'Unified Award Import',
  },
  {
    url: '/awards/unified-awards',
    permissionName: ['RSUAwards', 'OptionAwards', 'PSUAwards'],
    name: 'Unified Awards',
  },
  {
    url: '/awards/awards-agreement',
    permissionName: ['RSUAwards', 'OptionAwards', 'PSUAwards'],
    name: 'Award Agreement',
  },
  {
    url: '/awards/vesting-tranches',
    permissionName: ['RSUAwards', 'OptionAwards', 'PSUAwards'],
    name: 'Vesting Tranches',
  },
];
export const TransactionsList = [
  {
    url: '/transactions/release',
    permissionName: 'Release',
    name: 'Release',
  },
  {
    url: '/transactions/exercise',
    permissionName: 'OptionExercise',
    name: 'Exercise',
  },
  {
    url: '/transactions/purchase',
    permissionName: 'Release',
    name: 'Purchase',
  },
  {
    url: '/transactions/transfer-and-allocate',
    permissionName: 'TransferAllocate',
    name: 'Transfer and Allocate',
  },
  {
    url: '/transactions/drs-registration',
    permissionName: 'DrsRegistration',
    name: 'DRS Registration',
  },
  {
    url: '/transactions/external-transaction-import',
    permissionName: 'TransferAllocate',
    name: 'External Transaction Import',
  },
  {
    url: '/transactions/external-tax-import',
    permissionName: 'TransactionTaxImport',
    name: 'External Tax Import',
  },
  {
    url: '/transactions/inbound-share-transfer-import',
    permissionName: 'InboundShareTransfer',
    name: 'Inbound Share Transfer Import',
  },
  {
    url: '/transactions/unified-import-export',
    permissionName: 'StockSplit',
    name: 'Unified Transaction Import',
  },
];

export const TaskManagementConsole = [
  {
    url: 'task-management-console',
    permissionName: 'TaskManagerConsole',
    name: 'Job Console',
  },
];

export const ReportList = [
  {
    url: '/reports',
    permissionName: 'DynamicReport',
    name: 'Reports',
  },
];
